import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import generatePicker from 'antd/es/date-picker/generatePicker';

/**
 * antd v5 DatePicker'ı varsayılan olarak dayjs ile çalışır; bu proje baştan sona moment kullanıyor
 * (28 dosya: filtreler, takvim, randevu, grid sütunları). Tüm tarih mantığını dayjs'e çevirmek yerine
 * antd'nin resmî "custom date library" yolu kullanılır: picker moment ile üretilir.
 *
 * Kullanım v4 ile birebir aynı:
 *   import DatePicker from ".../core/components/DatePicker";
 *   <DatePicker />            <DatePicker.RangePicker />
 *
 * antd'den DatePicker/RangePicker import ETME — o dayjs bekler, moment nesnesiyle patlar.
 */
const DatePicker = generatePicker(momentGenerateConfig);

export default DatePicker;
export const RangePicker = DatePicker.RangePicker;
